<template>
    <dtg-modal-content>
        <template #title>
            Téléchargez l’application MyDTG
        </template>

        <div :class="b('content')">
            <p>Compatible sur tablette Apple iPad ou Android.</p>
            <div :class="b('stores')">
                <a
                    :class="b('store-link-apple')"

                    :href="appStoreUrl"

                    target="_blank"
                >
                    <img
                        :class="b('store-link-badge')"

                        :src="badgeAppStoreUrl"

                        alt="Télécharger dans l'App Store"
                    />
                </a>
                <a :href="playMarketUrl" target="_blank">
                    <img
                        :class="b('store-link-badge')"

                        alt="Disponible sur Google Play"
                        src="https://play.google.com/intl/en_us/badges/static/images/badges/fr_badge_web_generic.png"
                    />
                </a>
            </div>
            <p>
                <b>
                    Avez-vous déjà téléchargé l'app? Cliquez
                    <dtg-link href="/">
                        ICI
                    </dtg-link>
                    pour l'ouvrir et gérer vos DTG.
                </b>
            </p>
        </div>
    </dtg-modal-content>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

import { DtgLink, DtgModalContent, events, getName, useBem } from 'dtg-components';

import badgeAppStoreUrl from './badge-app-store.svg';
import { props } from './props';
import { DtgModalAppStoreEvents } from './types';

import styles from './style.module.scss';

export default defineComponent({
    name: getName(styles),

    components: {
        DtgModalContent,
        DtgLink,
    },

    props,

    emits: events(['close'])<DtgModalAppStoreEvents>(),

    setup() {
        const playMarketUrl =
            'https://play.google.com/store/apps/details?id=fr.kinaxia.dtg_mobile&pcampaignid=pcampaignidMKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1';
        const appStoreUrl = 'https://apps.apple.com/fr/app/mydtg/id1613744134';

        return {
            b: useBem(styles),

            badgeAppStoreUrl,

            appStoreUrl,
            playMarketUrl,
        };
    },
});
</script>

